import { c as _c } from "react/compiler-runtime";
import Chip from '@precis-digital/kurama/Chip';
import Grid from '@precis-digital/kurama/Grid';
import LocationIcon from '@precis-digital/kurama/icons/LocationIcon';
import Tooltip, { TooltipRichCaption, TooltipRichHeader } from '@precis-digital/kurama/Tooltip';
import Typography from '@precis-digital/kurama/Typography';
import { type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import { useCopilotCurrentPageLabel } from '../hooks/useCopilotCurrentPageLabel';
import { getCopilotNavigationTargetDisplay } from 'shared/copilot/tools/navigationCatalog';
import { useTranslation } from 'shared/translations';
import { buildCopilotLocationChipTooltipModel } from 'shared/copilot/utils/buildCopilotLocationChipTooltipModel';

/**
 * Drawer location chip with a rich tooltip of registered page context and tools.
 */
export const CopilotLocationChip = () => {
  const $ = _c(53);
  const {
    currentPageContext
  } = useCopilot();
  const {
    label: routeLabel
  } = useCopilotCurrentPageLabel();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot.locationChip"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let T0;
  let T1;
  let T2;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== currentPageContext || $[2] !== routeLabel || $[3] !== t) {
    const model = buildCopilotLocationChipTooltipModel(currentPageContext, routeLabel);
    const {
      icon: catalogIcon
    } = getCopilotNavigationTargetDisplay(model.pageId ?? undefined);
    T2 = Tooltip;
    t12 = "multiline";
    t13 = "320px";
    t14 = "360px";
    t15 = true;
    T1 = Grid;
    t6 = "flex";
    t7 = "column";
    t8 = "12px";
    t9 = <TooltipRichHeader avatar={catalogIcon} title={model.title} subtitle={routeLabel} />;
    t10 = !model.hasPageContext ? <TooltipRichCaption text={t("noPageContext")} /> : null;
    t11 = model.elements.length > 0 ? <Grid display="flex" flexDirection="column" gap="4px"><Typography variant="body2">{t("elementsHeading")}</Typography>{model.elements.map(_temp)}</Grid> : null;
    T0 = Grid;
    t1 = "flex";
    t2 = "column";
    t3 = "4px";
    let t16;
    if ($[22] !== t) {
      t16 = t("toolsHeading");
      $[22] = t;
      $[23] = t16;
    } else {
      t16 = $[23];
    }
    if ($[24] !== t16) {
      t4 = <Typography variant="body2">{t16}</Typography>;
      $[24] = t16;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    t5 = model.toolIds.map(_temp2);
    $[1] = currentPageContext;
    $[2] = routeLabel;
    $[3] = t;
    $[4] = T0;
    $[5] = T1;
    $[6] = T2;
    $[7] = t1;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t15;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[4];
    T1 = $[5];
    T2 = $[6];
    t1 = $[7];
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
    t15 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t16;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5) {
    t16 = <T0 display={t1} flexDirection={t2} gap={t3}>{t4}{t5}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== T1 || $[34] !== t10 || $[35] !== t11 || $[36] !== t16 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
    t17 = <T1 display={t6} flexDirection={t7} gap={t8}>{t9}{t10}{t11}{t16}</T1>;
    $[33] = T1;
    $[34] = t10;
    $[35] = t11;
    $[36] = t16;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LocationIcon />;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== routeLabel) {
    t19 = <Grid display="inline-flex"><Chip avatar={t18} label={routeLabel} /></Grid>;
    $[43] = routeLabel;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== T2 || $[46] !== t12 || $[47] !== t13 || $[48] !== t14 || $[49] !== t15 || $[50] !== t17 || $[51] !== t19) {
    t20 = <T2 kind={t12} width={t13} maxHeight={t14} allowOverflow={t15} content={t17}>{t19}</T2>;
    $[45] = T2;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
    $[49] = t15;
    $[50] = t17;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};
function _temp(element) {
  return <TooltipRichCaption key={element.id} text={`• ${element.label}`} />;
}
function _temp2(toolId) {
  return <TooltipRichCaption key={toolId} text={`• ${toolId}`} />;
}